/* Component Dependencies */
var contactUsTopicTextInfoTemplate = require('templates/contactUsTopicTextInfo.hbs');
var contactUsTopicTextInfoCreditCardTemplate = require('templates/contactUsTopicTextInfoCreditCard.hbs');
var contactUsTopicTextInfoMissingstayTemplate = require('templates/contactUsTopicTextInfoMissingstay.hbs');
var contactUsTopicTextInfoCombineAccountsTemplate = require('templates/contactUsTopicTextInfoCombineAccounts.hbs');
var contactUsTopicTextInfoEarningTemplate = require('templates/contactUsTopicTextInfoEarning.hbs');
var contactUsTopicTextInfoThankYouTemplate = require('templates/contactUsTopicTextInfoThankYou.hbs')
var AriesComponent = require('libs/aries-component');
const { template } = require('handlebars');

AriesComponent.create({
  type: 'contactUsTopicTextInfo',

  template: {
    'contactUsTopicTextInfo': contactUsTopicTextInfoTemplate,
    'contactUsTopicTextInfoCreditCard': contactUsTopicTextInfoCreditCardTemplate,
    'contactUsTopicTextInfoMissingstay': contactUsTopicTextInfoMissingstayTemplate,
    'contactUsTopicTextInfoCombineAccounts': contactUsTopicTextInfoCombineAccountsTemplate,
    'contactUsTopicTextInfoEarning': contactUsTopicTextInfoEarningTemplate,
    'contactUsTopicTextInfoThankYou': contactUsTopicTextInfoThankYouTemplate
  },

  subscribe: {
    'TOGGLE_VISIBLE_CONTACTUS_TEXT_INFO': 'toggleVisiablity',
  },
  /**
  * This function will trigger on subscribe event to toggle Visiablity of tile
  */
  toggleVisiablity: function _toggleVisiablity (data) {
    var version = data.version, visible = data.visible,
        templateArray = ['contactUsTopicTextInfo', 'contactUsTopicTextInfoCreditCard', 'contactUsTopicTextInfoMissingstay', 'contactUsTopicTextInfoCombineAccounts', 'contactUsTopicTextInfoEarning'];

    if (visible) {
      templateArray.map(function (item, index) {
        if (item === version) {
          $('#'+item).removeClass('is-hidden')
        }
      })
    } else {
      this.$el.addClass('is-hidden');
    }
  }
});